import { SimID } from 'console/sim/types';
const initial_state = {
    open: false,
    text: '',
};
export function propopup_reducer(state = initial_state, action) {
    switch (action.type) {
        case 'OPEN_PRO_POPUP':
            return {
                ...state,
                open: true,
                text: action.text,
            };
        case 'CLOSE_PRO_POPUP':
            return { ...state, ...initial_state };
        default:
            return state;
    }
}
export function create_account_reducer(initial_state) {
    return (state = initial_state, action) => {
        switch (action.type) {
            case 'APPLY_EMAIL_CONFIRMED':
                return { ...state, email_confirmed: true };
            case 'SET_EMAIL__OK':
                return { ...state, email: action.email };
            case 'UPDATE_BILLED_SIM': {
                const existing = state.sims ?? [];
                if (existing.filter((sim) => SimID.equals(sim.sim_card.id, action.billed_sim.sim_card.id)).length === 0)
                    return {
                        ...state,
                        sims: [...existing, action.billed_sim],
                    };
                else
                    return {
                        ...state,
                        sims: existing.map((sim) => {
                            if (SimID.equals(sim.sim_card.id, action.billed_sim.sim_card.id))
                                return action.billed_sim;
                            return sim;
                        }),
                    };
            }
            case 'UPDATE_FOREIGN_SIM': {
                const existing = state.foreign_sims ?? [];
                if (existing.filter((fsim) => fsim.msisdn === action.foreign_sim.msisdn)
                    .length === 0)
                    return {
                        ...state,
                        foreign_sims: [...existing, action.foreign_sim],
                    };
                else
                    return {
                        ...state,
                        foreign_sims: existing.map((sim) => {
                            if (sim.msisdn === action.foreign_sim.msisdn)
                                return { ...action.foreign_sim };
                            return sim;
                        }),
                    };
            }
            case 'UPDATE_ACCOUNT__OK':
                return { ...state, ...action.update };
            case 'REMOVE_FOREIGN_SIM': {
                const existing = state.foreign_sims ?? [];
                return {
                    ...state,
                    foreign_sims: existing.filter((sim) => sim.msisdn !== action.msisdn),
                };
            }
            case 'REMOVE_BILLED_SIM': {
                const existing = state.sims ?? [];
                return {
                    ...state,
                    sims: existing.filter((sim) => sim.sim_card.msisdn !== action.msisdn),
                };
            }
            case 'DATE_LAST_READ_NEWS__UPDATE__REQUEST':
                return {
                    ...state,
                    date_last_news_reading: new Date().getTime() / 1000,
                };
            case 'GET_ACCOUNT__OK':
                return {
                    ...state,
                    ...action.account,
                };
            case 'UPDATE_ORG_DETAILS':
                return {
                    ...state,
                    org_details: action.org_details,
                };
            case 'CHANGE_UI_GUIDE_GROUP_STATUS':
                if ((state.ui_guide_statuses ?? []).some(({ group_id }) => group_id == action.group_id)) {
                    // тогда меняем
                    return {
                        ...state,
                        ui_guide_statuses: (state.ui_guide_statuses ?? []).map((status) => {
                            if (status.group_id == action.group_id) {
                                const { group_id, type, ...rest } = action;
                                return { ...status, ...rest };
                            }
                            return status;
                        }),
                    };
                }
                else {
                    const { type, ...rest } = action;
                    return {
                        ...state,
                        ui_guide_statuses: [
                            ...(state.ui_guide_statuses ?? []),
                            {
                                attempts: 1,
                                passed: false,
                                rejected: false,
                                skipped: false,
                                ...rest,
                            },
                        ],
                    };
                }
            case 'UPDATE_ALLOW_DESIGN_PACKAGE': {
                return {
                    ...state,
                    allow_design_package: action.allow_design_package,
                };
            }
            default:
                return state;
        }
    };
}
